
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Bachelor in Computer application (BCA)</h1>
                </div>
            </div>
        </div>          
    </div>  
</section>   

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Course Outcomes</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>10+2 or any other equivalent examination from a recognized board. Aspirants must have studied Mathematics or Statistics as a compulsory subject in Class 12Age must be below 25 years.</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Duration
                            </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>3 years ( 6 Semesters</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>Subjects
                            </h3>
                           
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">B.C.A. Part I</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 1</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>-</td>
                                        <td>English</td>
                                        <td>-</td>
                                        <td>English</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                        <td>Marathi/Hindi/Urdu/Gujarati/Sanskrit / Suppl. English</td>
                                        <td>-</td>
                                        <td>Marathi/Hindi/Urdu/Gujarati/Sanskrit / Suppl. English</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - I</td>
                                        <td>Computer Fundamentals</td>
                                        <td>Paper - I</td>
                                        <td>Programming In ‘C++’</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - II</td>
                                        <td>“C” Programming</td>
                                        <td>Paper - II</td>
                                        <td>System Analysis And Design</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - III</td>
                                        <td>Statistical Methods</td>
                                        <td>Paper - III</td>
                                        <td>Numerical Methods</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - IV</td>
                                        <td>Discrete Mathematics – I</td>
                                        <td>Paper - IV</td>
                                        <td>Discrete Mathematics – II</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - V</td>
                                        <td>Operating Systems</td>
                                        <td>Paper - V</td>
                                        <td>Linux Operating System</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - VI</td>
                                        <td>Office Automation</td>
                                        <td>Paper - VI</td>
                                        <td>E Commerce</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">B.C.A. Part II</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 3</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Paper - I</td>
                                        <td>Visual Basic Programming</td>
                                        <td>Paper - I</td>
                                        <td>Software Engineering-I</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - II</td>
                                        <td>Data Base Management System</td>
                                        <td>Paper - II</td>
                                        <td>Sql And Pl/Sq</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - III</td>
                                        <td>Data Structures</td>
                                        <td>Paper - III</td>
                                        <td>Theory Of Computation</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - IV</td>
                                        <td>Operations Research – I</td>
                                        <td>Paper - IV</td>
                                        <td>Operations Research - II</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - V</td>
                                        <td>Web Technology - I</td>
                                        <td>Paper - V</td>
                                        <td>Web Technology - II</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - VI</td>
                                        <td>Digital Electronics – I</td>
                                        <td>Paper - VI</td>
                                        <td>Digital Electronics – II</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">B.C.A. Part III</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 5</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 6</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Paper - I</td>
                                        <td>Computer Graphics - I</td>
                                        <td>Paper - I</td>
                                        <td>Computer Graphics - II</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - II</td>
                                        <td>Compiler Construction</td>
                                        <td>Paper - II</td>
                                        <td>Programming In Java</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - III</td>
                                        <td>VB.Net</td>
                                        <td>Paper - III</td>
                                        <td>ASP.Net</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - IV</td>
                                        <td>Software Engineering - II </td>
                                        <td>Paper - IV</td>
                                        <td>Software Testing</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - V</td>
                                        <td>PHP - I</td>
                                        <td>Paper - V</td>
                                        <td>PHP - II</td>
                                    </tr>
                                    <tr>
                                        <td>Paper - VI</td>
                                        <td>Data Communication And Network - I</td>
                                        <td>Paper - VI</td>
                                        <td>Data Communication And Network - II</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                        <td>Practical - I</td>
                                        <td>Practical I – based on paper I & paper II</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                        <td>Practical - II</td>
                                        <td>Practical II – based on paper IV &  paper V</td>
                                    </tr>
                                    <tr>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                        <td>Practical - III</td>
                                        <td>Practical III – based on paper V &  paper VI</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Scope :</strong>  MCA  , MBA , MCM </li>
                            <li><strong>Prospects:</strong> Software developer, web developer, Mobile application developer</li>
                        </ul>
                    </div>
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
                        <div class="inner-title"  >
                            <h3>Course Outcomes of BCA-I Year</h3>
                           
                        </div> 
                        <div class="inner-title">
                            <h4>1) Engish- Vinod Chavan</h4>
                         </div>
                         <ul class="list-item">
                             <li> Students are able to make proper use of vocabulary in verbal and written communication.</li>
                             <li> Students are able to learn how technology uplifted and enabled the mankind, out of the information and ideas in prose and poems.</li>
                             <li> Students are delighted with the knowledge of self-determination, hope, emotional values and ambition of human being.</li>
                             <li> Students are able to use of basic grammar, tense, verbs and prepositions.</li>
                         </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>2)Statistical Method-Vikas Chaorashe</h4>
                         </div>
                        <ul class="list-item">
                             <li>Students will be able to understand the concept, purpose, application and limitation of Statistical Method.</li>
                             <li>Students will be able to understand the concept of central tendency and applications of central tendency.</li>
                             <li>The student should be able to estimate the dispersion / variance symmetry of the data using various measures and draw inferences to facilitate decision making.</li>
                             <li>The students should also be able to able assess the level of association between given variables by using various types of correlation techniques and predict the values of a variable using regression analysis techniques analysis.</li>
                          </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>3) Discrete mathematics-Gaurav Khobragade </h4>
                         </div>
                         <ul class="list-item">
                            <li>Students will able to understand the basic concepts of statements and notations</li>
                            <li>Students will able to understand different normal forms in logic.</li>
                            <li> Students will able to understand the theory of inference in mathematical logic.</li>
                            <li>Student will able to understand the predicate logic.</li>
                         </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>4) Operating System -Ashwin Ankar </h4>
                         </div>
                         <ul class="list-item">
                            <li>Able to understand the structure of OS, interpret Process management and CPU    scheduling.</li>
                            <li> Able to identify the concepts of Deadlocks and starvation                            </li>
                            <li>Able to classify the different memory management techniques                            </li>
                            <li> Able to understand I/O management and File management.</li>
                         </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>5) Office Automation-Madhura Chinchamalatpure                            </h4>
                         </div>
                         <ul class="list-item">
                            <li>Students will learn about windows Operating System and its commands</li>
                           <li> Students were made familiar with the need of Microsoft Office in our daily lives.</li>
                           <li> Students will be made familiar with introduction to MS EXCEL.</li>
                           <li>With the help of labs, students became familiar with MS POWER POINT.</li>
                         </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>6) Supplementary English -Supriya Dupare</h4>
                         </div>
                         <ul class="list-item">
                            <li>Students will be able to develop sensitivity and sensibility relating through the experiences of the characters in the stories.</li>
                            <li> Students will be able to inculcate in them the message and values through the stories.</li>
                            <li> Students will be able to make use of expanded vocabulary in practical ways.</li>
                            <li>Students will be able to compose different forms of written communication .</li>
                        </ul>
                         <hr>
                         <div class="inner-title">
                             <h4>7) FOC -Madhuri Barua</h4>
                         </div>
                         <ul class="list-item">
                            <li>To provide a foundation of computing principles and business practices for effectively using/managing information systems and enterprise software.</li>
                            <li>To get acquainted with the various types of storage units and memory management.</li>
                            <li>To get acquainted with the various types of input and output devices.</li>
                            <li> To understand the Networking concepts.</li>
                         </ul>
                    </div>
                </div>                
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
            </div>
        </div>
    </div>
</section>

